<template>
  <component :is="multiple ? 'li' : 'div'">
    <RevLink
      v-if="parsedForm === 'link'"
      :id="ctaId"
      :ariaLabelledby="parsedAriaLabelledBy"
      data-test="spotlight-link"
      :rel="link.rel"
      :target="link.target"
      :to="link.href"
      @click="onCTAClick"
    >
      {{ label }}
    </RevLink>

    <RevButton
      v-if="parsedForm === 'square'"
      :id="ctaId"
      :ariaLabelledby="parsedAriaLabelledBy"
      class="!max-w-fit !md:max-w-[326px] !w-full"
      data-test="spotlight-square-button"
      :rel="link.rel"
      size="medium"
      :target="link.target"
      :to="link.href"
      :variant="parsedVariant"
      @click="onCTAClick"
    >
      {{ label }}
    </RevButton>
  </component>
</template>

<script setup lang="ts">
import type { ProductSpotlightCtaApiProps } from '@backmarket/http-api/src/api-specs-content/models/product-spotlight'
import type { Tracking } from '@backmarket/http-api/src/api-specs-content/models/tracking'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevLink } from '@ds/components/Link'

const {
  label,
  variant,
  form,
  link,
  tracking,
  // For accessibility, use this prop when displaying a list of SpotlightCTAs
  multiple = false,
  // For accessibility, use this prop to link the CTA to another text field for more context on the CTA action
  ariaLabelledBy = '',
} = defineProps<
  ProductSpotlightCtaApiProps & {
    tracking: Tracking
    multiple?: boolean
    ariaLabelledBy?: string
  }
>()

const { trackClick } = useTracking()

const ctaId = `product-spotlight-cta-${form}-${variant}`
const parsedAriaLabelledBy = ariaLabelledBy
  ? `${ctaId} ${ariaLabelledBy}`
  : ctaId
const parsedVariant = variant ?? 'primary'
const parsedForm = parseForm()

function onCTAClick() {
  trackClick({
    ...tracking,
    source: 'ProductSpotlight',
    name: label,
    link: link.href,
  })
}

function parseForm() {
  if (!form) return 'link'
  if (form !== 'link' && form !== 'square') return 'link'

  return form
}
</script>
